module.exports = __webpack_public_path__ + "img/koguna.63ac1e60.jpg";